module.exports = __webpack_public_path__ + "area_total_dark.fe7c039f.png";